<script setup>
import { useSportLiveTvLogo } from '@/sport-live-tv/composables/use-sport-live-tv-logo';

const props = defineProps({
  event: { type: Object, required: true },
});

const { src, handleError } = useSportLiveTvLogo(() => props.event);
</script>

<template>
  <div class="sport-live-tv-event-logo">
    <img v-if="src" :key="src" :src="src" :alt="event.category_name" class="sport-live-tv-event-logo__image" @error="handleError" />
    <span v-else class="sport-live-tv-event-logo__placeholder">{{ event.category_name }}</span>
  </div>
</template>

<style lang="scss" scoped>
.sport-live-tv-event-logo {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  aspect-ratio: 16 / 9;
  overflow: hidden;
  border-radius: 6px;
  background-color: $black30;

  &__image {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  &__placeholder {
    color: $white10;
    font-size: 13px;
    font-weight: 700;
  }
}
</style>
